import { Button, Menu, MenuItem, Typography } from "@mui/material";
import { useState } from "react";
import { useAuth } from '../contexts/authContext'
import { doSignOut } from "../firebase/auth";

interface UserDetailsProps {
    selectTab: (newValue: number) => void
}

function UserDetailsPanel({ selectTab }: UserDetailsProps) {

    const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleLogout = () => {
        doSignOut()
        setAnchorElUser(null)
    }

    const handleInstitution = () => {
        selectTab(7)
    }

    const { currentUser, isPaidIndividualCustomer, customerId, institutionalRoles } = useAuth()

    return <><Button
        color='primary'
        variant="contained"
        size="small"
        component="a"
        onClick={handleOpenUserMenu}
    >
        {currentUser ? (currentUser.displayName ? currentUser.displayName : currentUser.email) : "Not authenticated"}
    </Button>
        <Menu
            sx={{ mt: '45px' }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
        >
            <MenuItem key='user-menu-logout' onClick={handleLogout}>
                <Typography sx={{ textAlign: 'center' }}>Logout</Typography>
            </MenuItem>
            {isPaidIndividualCustomer &&
                <MenuItem key='user-menu-manage-subscriptions'>
                    <form action="https://www.scitility.com/payment/api/v1/create-portal-session" method="POST">
                        <input
                            type="hidden"
                            id="customer-id"
                            name="customer_id"
                            value={customerId}
                        />
                        <button id="checkout-and-portal-button" type="submit">
                            Manage my subscription
                        </button>
                    </form>
                </MenuItem>
            }
            {institutionalRoles.length > 0 &&
                institutionalRoles[0][1] === 'Admin'
                && <MenuItem key='user-menu-manage-institution'>
                    <button id="manage-my-institution-button" onClick={handleInstitution}>
                        Manage my institution
                    </button>
                </MenuItem>
            }
        </Menu>
    </>
}

export default UserDetailsPanel